import type { DateTime } from "luxon"
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar type represents time data, represented as an ISO-8601 encoded UTC date string. */
  DateTime: DateTime;
  /** The `FrozenDate` scalar type represents time data, represented as an ISO-8601 encoded UTC date string. */
  FrozenDate: DateTime;
  /** The `FrozenTime` scalar type represents time data, represented as an ISO-8601 encoded UTC date string. */
  FrozenTime: DateTime;
};

export type Address = {
  __typename?: 'Address';
  additional?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  nr: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type AddressInput = {
  additional?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  name: Scalars['String'];
  sort?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type AddStructure = {
  addresses?: InputMaybe<Array<AddressInput>>;
  contactInfos?: InputMaybe<Array<ContactInfoInput>>;
  custom_type_id?: InputMaybe<Scalars['ID']>;
  external_id?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<ClassificationMetadataInput>;
  parent_id?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
  type: ClassificationTypeEnum;
};

export type Article = {
  __typename?: 'Article';
  content: Scalars['String'];
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  files: Array<File>;
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  published: Scalars['DateTime'];
  read: Scalars['Boolean'];
  title: Scalars['String'];
  viewCount: Scalars['Int'];
};

export type ArticleClassification = ClassificationInterface & {
  __typename?: 'ArticleClassification';
  addresses: Array<Address>;
  allowedSubTypes: Array<ClassificationTypeEnum>;
  archived?: Maybe<Scalars['DateTime']>;
  awardedPins: Array<ClassificationsPin>;
  boughtDevices: PorpaginasResult_Device;
  boughtDevicesCount: Scalars['Int'];
  childClassifications: PorpaginasResult_NormalClassification;
  contactInfos: Array<ContactInfo>;
  created: Scalars['DateTime'];
  customType?: Maybe<ClassificationCustomType>;
  deleted?: Maybe<Scalars['DateTime']>;
  devices: PorpaginasResult_Device;
  devicesSales: Array<DevicesSale>;
  devicesSalesCount: Scalars['Int'];
  external_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  metadata?: Maybe<ClassificationMetadata>;
  modified: Scalars['DateTime'];
  /**
   * Get type of next typed classification.
   * If type of this Entity is 'custom' the type of the next parent with a type other than 'custom' will be returned.
   * Otherwise, the type of this Entity is returned
   */
  nextTypedClassificationType: ClassificationTypeEnum;
  /**
   * Get parent_classification field.
   * Strange Function name is for backwards compatibility
   */
  parent_classification?: Maybe<NormalClassification>;
  parent_id?: Maybe<Scalars['ID']>;
  /** Get First parentClassification that matches conditions */
  parentClassification?: Maybe<NormalClassification>;
  parentClassifications: Array<NormalClassification>;
  pins: PorpaginasResult_Pin;
  points: PorpaginasResult_Point;
  purchases: PorpaginasResult_Sale;
  quotas: PorpaginasResult_Quota;
  ratingdatas: PorpaginasResult_Ratingdata;
  readDate: Scalars['DateTime'];
  /**
   * The total sale count of classification (of sales and Ratingdatas table)
   * This field only has data when returned from getTopImporters.
   */
  saleCount: Scalars['Int'];
  sales: PorpaginasResult_Sale;
  soldDevices: PorpaginasResult_Device;
  stars: PorpaginasResult_Star;
  title: Scalars['String'];
  type: ClassificationTypeEnum;
  users: Array<User>;
  usersPaginated: PorpaginasResult_User;
};


export type ArticleClassificationDevicesSalesArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type ArticleClassificationDevicesSalesCountArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type ArticleClassificationParentClassificationArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type ArticleClassificationParentClassificationsArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type ArticleClassificationPurchasesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};


export type ArticleClassificationRatingdatasArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type ArticleClassificationSalesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};

export type ArticleFilterInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type ArticlesFileInput = {
  file_id: Scalars['ID'];
  sort: Scalars['Int'];
};

export enum ArticleSorterFields {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DeletedAsc = 'DELETED_ASC',
  DeletedDesc = 'DELETED_DESC',
  ModifiedAsc = 'MODIFIED_ASC',
  ModifiedDesc = 'MODIFIED_DESC',
  PublishedAsc = 'PUBLISHED_ASC',
  PublishedDesc = 'PUBLISHED_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  ViewCountAsc = 'VIEW_COUNT_ASC',
  ViewCountDesc = 'VIEW_COUNT_DESC'
}

export type ArticleSorterInput = {
  fields: Array<ArticleSorterFields>;
};

export type CalculatedClassification = {
  __typename?: 'CalculatedClassification';
  calculated: CalculationEntryInterface;
  calculations: Array<DatedCalculationEntry>;
  classification: NormalClassification;
  datedCalculations: Array<DatedCalculationEntry>;
  saleEntries: Array<DatedCalculationEntry>;
  saleEntry?: Maybe<CalculationEntryInterface>;
  totalData: CalculationEntryInterface;
};


export type CalculatedClassificationCalculatedArgs = {
  date: Scalars['DateTime'];
};


export type CalculatedClassificationSaleEntryArgs = {
  date: Scalars['DateTime'];
};

export type CalculatedClassificationInput = {
  classification: Scalars['ID'];
  entries: Array<DatedCalculationEntryInput>;
  quotas: Array<Scalars['ID']>;
  ratingdatas: Array<Scalars['ID']>;
};

export type CalculationEntry = CalculationEntryInterface & {
  __typename?: 'CalculationEntry';
  data: EntryData;
  growth: Scalars['Int'];
  quota: Scalars['Int'];
  quotaTarget: Scalars['Int'];
};

export enum CalculationEntryDataTypeEnum {
  Bought = 'BOUGHT',
  Free = 'FREE',
  Sold = 'SOLD',
  Warranty = 'WARRANTY'
}

export type CalculationEntryInterface = {
  data: EntryData;
  growth: Scalars['Int'];
  quota: Scalars['Int'];
  quotaTarget: Scalars['Int'];
};

export type Champion = ClassificationInterface & {
  __typename?: 'Champion';
  addresses: Array<Address>;
  allowedSubTypes: Array<ClassificationTypeEnum>;
  archived?: Maybe<Scalars['DateTime']>;
  awardedPins: Array<ClassificationsPin>;
  boughtDevices: PorpaginasResult_Device;
  boughtDevicesCount: Scalars['Int'];
  childClassifications: PorpaginasResult_NormalClassification;
  classification: NormalClassification;
  contactInfos: Array<ContactInfo>;
  created: Scalars['DateTime'];
  customType?: Maybe<ClassificationCustomType>;
  date: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  devices: PorpaginasResult_Device;
  devicesSales: Array<DevicesSale>;
  devicesSalesCount: Scalars['Int'];
  external_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  metadata?: Maybe<ClassificationMetadata>;
  modified: Scalars['DateTime'];
  /**
   * Get type of next typed classification.
   * If type of this Entity is 'custom' the type of the next parent with a type other than 'custom' will be returned.
   * Otherwise, the type of this Entity is returned
   */
  nextTypedClassificationType: ClassificationTypeEnum;
  /**
   * Get parent_classification field.
   * Strange Function name is for backwards compatibility
   */
  parent_classification?: Maybe<NormalClassification>;
  parent_id?: Maybe<Scalars['ID']>;
  /** Get First parentClassification that matches conditions */
  parentClassification?: Maybe<NormalClassification>;
  parentClassifications: Array<NormalClassification>;
  pins: PorpaginasResult_Pin;
  points: PorpaginasResult_Point;
  purchases: PorpaginasResult_Sale;
  quotas: PorpaginasResult_Quota;
  ratingdatas: PorpaginasResult_Ratingdata;
  saleCount: Scalars['Int'];
  sales: PorpaginasResult_Sale;
  soldDevices: PorpaginasResult_Device;
  stars: PorpaginasResult_Star;
  title: Scalars['String'];
  type: ClassificationTypeEnum;
  users: Array<User>;
  usersPaginated: PorpaginasResult_User;
};


export type ChampionDevicesSalesArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type ChampionDevicesSalesCountArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type ChampionParentClassificationArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type ChampionParentClassificationsArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type ChampionPurchasesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};


export type ChampionRatingdatasArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type ChampionSalesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};

export type Classification = ClassificationInterface & {
  __typename?: 'Classification';
  addresses: Array<Address>;
  allowedSubTypes: Array<ClassificationTypeEnum>;
  archived?: Maybe<Scalars['DateTime']>;
  awardedPins: Array<ClassificationsPin>;
  boughtDevices: PorpaginasResult_Device;
  boughtDevicesCount: Scalars['Int'];
  childClassifications: PorpaginasResult_NormalClassification;
  contactInfos: Array<ContactInfo>;
  created: Scalars['DateTime'];
  customType?: Maybe<ClassificationCustomType>;
  deleted?: Maybe<Scalars['DateTime']>;
  devices: PorpaginasResult_Device;
  devicesSales: Array<DevicesSale>;
  devicesSalesCount: Scalars['Int'];
  external_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  metadata?: Maybe<ClassificationMetadata>;
  modified: Scalars['DateTime'];
  /**
   * Get type of next typed classification.
   * If type of this Entity is 'custom' the type of the next parent with a type other than 'custom' will be returned.
   * Otherwise, the type of this Entity is returned
   */
  nextTypedClassificationType: ClassificationTypeEnum;
  /**
   * Get parent_classification field.
   * Strange Function name is for backwards compatibility
   */
  parent_classification?: Maybe<NormalClassification>;
  parent_id?: Maybe<Scalars['ID']>;
  /** Get First parentClassification that matches conditions */
  parentClassification?: Maybe<NormalClassification>;
  parentClassifications: Array<NormalClassification>;
  pins: PorpaginasResult_Pin;
  points: PorpaginasResult_Point;
  purchases: PorpaginasResult_Sale;
  quotas: PorpaginasResult_Quota;
  ratingdatas: PorpaginasResult_Ratingdata;
  /**
   * The total sale count of classification (of sales and Ratingdatas table)
   * This field only has data when returned from getTopImporters.
   */
  saleCount: Scalars['Int'];
  sales: PorpaginasResult_Sale;
  soldDevices: PorpaginasResult_Device;
  stars: PorpaginasResult_Star;
  title: Scalars['String'];
  type: ClassificationTypeEnum;
  users: Array<User>;
  usersPaginated: PorpaginasResult_User;
};


export type ClassificationDevicesSalesArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type ClassificationDevicesSalesCountArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type ClassificationParentClassificationArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type ClassificationParentClassificationsArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type ClassificationPurchasesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};


export type ClassificationRatingdatasArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type ClassificationSalesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};

export type ClassificationCode = {
  __typename?: 'ClassificationCode';
  classification: NormalClassification;
  code: Scalars['String'];
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
};

export type ClassificationCodeInput = {
  classification_id?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ClassificationCustomType = {
  __typename?: 'ClassificationCustomType';
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  importer: ClassificationInterface;
  modified: Scalars['DateTime'];
  title: Scalars['String'];
};

export type ClassificationCustomTypesFilterInput = {
  classification_id?: InputMaybe<Scalars['ID']>;
  importer_id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ClassificationFilterInput = {
  active?: InputMaybe<Scalars['DateTime']>;
  excludeGermany?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<IdMatcherInput>;
  fullTitle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  sameImporterAs?: InputMaybe<Scalars['ID']>;
  siblingOf?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<ClassificationTypeEnum>>;
};

export type ClassificationInterface = {
  addresses: Array<Address>;
  allowedSubTypes: Array<ClassificationTypeEnum>;
  archived?: Maybe<Scalars['DateTime']>;
  awardedPins: Array<ClassificationsPin>;
  boughtDevices: PorpaginasResult_Device;
  boughtDevicesCount: Scalars['Int'];
  childClassifications: PorpaginasResult_NormalClassification;
  contactInfos: Array<ContactInfo>;
  created: Scalars['DateTime'];
  customType?: Maybe<ClassificationCustomType>;
  deleted?: Maybe<Scalars['DateTime']>;
  devices: PorpaginasResult_Device;
  devicesSales: Array<DevicesSale>;
  devicesSalesCount: Scalars['Int'];
  external_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  metadata?: Maybe<ClassificationMetadata>;
  modified: Scalars['DateTime'];
  /**
   * Get type of next typed classification.
   * If type of this Entity is 'custom' the type of the next parent with a type other than 'custom' will be returned.
   * Otherwise, the type of this Entity is returned
   */
  nextTypedClassificationType: ClassificationTypeEnum;
  /**
   * Get parent_classification field.
   * Strange Function name is for backwards compatibility
   */
  parent_classification?: Maybe<NormalClassification>;
  parent_id?: Maybe<Scalars['ID']>;
  /** Get First parentClassification that matches conditions */
  parentClassification?: Maybe<NormalClassification>;
  parentClassifications: Array<NormalClassification>;
  pins: PorpaginasResult_Pin;
  points: PorpaginasResult_Point;
  purchases: PorpaginasResult_Sale;
  quotas: PorpaginasResult_Quota;
  ratingdatas: PorpaginasResult_Ratingdata;
  /**
   * The total sale count of classification (of sales and Ratingdatas table)
   * This field only has data when returned from getTopImporters.
   */
  saleCount: Scalars['Int'];
  sales: PorpaginasResult_Sale;
  soldDevices: PorpaginasResult_Device;
  stars: PorpaginasResult_Star;
  title: Scalars['String'];
  type: ClassificationTypeEnum;
  users: Array<User>;
  usersPaginated: PorpaginasResult_User;
};


export type ClassificationInterfaceDevicesSalesArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type ClassificationInterfaceDevicesSalesCountArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type ClassificationInterfaceParentClassificationArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type ClassificationInterfaceParentClassificationsArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type ClassificationInterfacePurchasesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};


export type ClassificationInterfaceRatingdatasArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type ClassificationInterfaceSalesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};

export type ClassificationMetadata = {
  __typename?: 'ClassificationMetadata';
  birthday?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  entry_date?: Maybe<Scalars['DateTime']>;
  first_name?: Maybe<Scalars['String']>;
  gender: GenderEnum;
  id: Scalars['String'];
  last_name?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  note?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ClassificationMetadataInput = {
  birthday?: InputMaybe<Scalars['DateTime']>;
  company?: InputMaybe<Scalars['String']>;
  entry_date?: InputMaybe<Scalars['DateTime']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderEnum>;
  last_name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum ClassificationSorterFields {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DeletedAsc = 'DELETED_ASC',
  DeletedDesc = 'DELETED_DESC',
  ModifiedAsc = 'MODIFIED_ASC',
  ModifiedDesc = 'MODIFIED_DESC',
  ParentTitleAsc = 'PARENT_TITLE_ASC',
  ParentTitleDesc = 'PARENT_TITLE_DESC',
  SalesCountAsc = 'SALES_COUNT_ASC',
  SalesCountDesc = 'SALES_COUNT_DESC',
  StarCountAsc = 'STAR_COUNT_ASC',
  StarCountDesc = 'STAR_COUNT_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type ClassificationSorterInput = {
  fields: Array<ClassificationSorterFields>;
};

export type ClassificationsPin = {
  __typename?: 'ClassificationsPin';
  classification: NormalClassification;
  classifications_pins_ratingdatas: Array<ClassificationsPinsRatingdata>;
  created: Scalars['FrozenTime'];
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  modified: Scalars['FrozenTime'];
  persistent: Scalars['Boolean'];
  pin: Pin;
};

export type ClassificationsPinsRatingdata = {
  __typename?: 'ClassificationsPinsRatingdata';
  pinrule: Pinrule;
  ratingdata: Ratingdata;
};

export enum ClassificationTypeEnum {
  Consultant = 'CONSULTANT',
  Country = 'COUNTRY',
  Custom = 'CUSTOM',
  Customer = 'CUSTOMER',
  Distributor = 'DISTRIBUTOR',
  Importer = 'IMPORTER',
  MediaConsultant = 'MEDIA_CONSULTANT',
  Organization = 'ORGANIZATION',
  Region = 'REGION',
  Root = 'ROOT'
}

export type CompareClassification = {
  __typename?: 'CompareClassification';
  allTotalIntervals: Array<IntervalCalculationEntry>;
  calculatedClassification: CalculatedClassification;
  currentTotalInterval: IntervalCalculationEntry;
  dates: Array<DateDiff>;
  growth: Scalars['Float'];
  previousTotalInterval: IntervalCalculationEntry;
};


export type CompareClassificationGrowthArgs = {
  base?: InputMaybe<Scalars['Int']>;
  type: CalculationEntryDataTypeEnum;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  number: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
  title: ContactInfoType;
};

export type ContactInfoInput = {
  description?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
  sort?: InputMaybe<Scalars['Int']>;
  title: ContactInfoType;
};

export enum ContactInfoType {
  Fax = 'FAX',
  Mail = 'MAIL',
  Mobile = 'MOBILE',
  Phone = 'PHONE'
}

export type CreateArticle = {
  content: Scalars['String'];
  files: Array<ArticlesFileInput>;
  published: Scalars['DateTime'];
  title: Scalars['String'];
};

export type CreateClassificationsPin = {
  classification_id: Scalars['ID'];
  date: Scalars['FrozenDate'];
  pin_id: Scalars['ID'];
};

export type CreateCustomType = {
  importer_id?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};

export type CreateDeviceType = {
  description?: InputMaybe<Scalars['String']>;
  has_serial: Scalars['Boolean'];
  importer_serial: Scalars['Boolean'];
  ranking: Scalars['Boolean'];
  ranking_end?: InputMaybe<Scalars['FrozenDate']>;
  ranking_start?: InputMaybe<Scalars['FrozenDate']>;
  sort?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  type_serial?: InputMaybe<Scalars['String']>;
};

export type CreateEvent = {
  content: Scalars['String'];
  end_date: Scalars['DateTime'];
  header_id?: InputMaybe<Scalars['ID']>;
  location: Scalars['String'];
  notification_start?: InputMaybe<Scalars['DateTime']>;
  registration_until: Scalars['DateTime'];
  start_date: Scalars['DateTime'];
  title: Scalars['String'];
};

export type CreateEventRegistration = {
  email: Scalars['String'];
  event_id: Scalars['ID'];
  first_name: Scalars['String'];
  importer_id?: InputMaybe<Scalars['ID']>;
  last_name: Scalars['String'];
  position: EventRegistrationPosition;
};

export type DatedCalculationEntry = CalculationEntryInterface & {
  __typename?: 'DatedCalculationEntry';
  data: EntryData;
  date: Scalars['DateTime'];
  growth: Scalars['Int'];
  quota: Scalars['Int'];
  quotaTarget: Scalars['Int'];
};

export type DatedCalculationEntryInput = {
  data?: InputMaybe<EntryDataInput>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type DatedEntryData = DatedValueInterface & {
  __typename?: 'DatedEntryData';
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  value: EntryData;
};

export type DateDiff = {
  __typename?: 'DateDiff';
  allDates: Array<Scalars['DateTime']>;
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type DatedInt = DatedValueInterface & {
  __typename?: 'DatedInt';
  date: Scalars['DateTime'];
  value: Scalars['Int'];
};

export type DatedValue = DatedValueInterface & {
  __typename?: 'DatedValue';
  date: Scalars['DateTime'];
};

export type DatedValueInterface = {
  date: Scalars['DateTime'];
};

export type DateRangeFilterInput = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type DestructuredSerial = {
  __typename?: 'DestructuredSerial';
  afterSequence?: Maybe<Scalars['String']>;
  beforeSequence?: Maybe<Scalars['String']>;
  importer?: Maybe<Scalars['String']>;
  sequence: Scalars['Int'];
  sequenceSize: Scalars['Int'];
  serial: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type Device = {
  __typename?: 'Device';
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  devicesSales: Array<DevicesSale>;
  devicetype: Devicetype;
  id: Scalars['ID'];
  latest_devices_sale?: Maybe<DevicesSale>;
  modified: Scalars['DateTime'];
  production?: Maybe<Scalars['DateTime']>;
  sale?: Maybe<Sale>;
  serial?: Maybe<Scalars['String']>;
  shipment: Shipment;
};

export type DeviceCountClassification = ClassificationInterface & {
  __typename?: 'DeviceCountClassification';
  addresses: Array<Address>;
  allowedSubTypes: Array<ClassificationTypeEnum>;
  archived?: Maybe<Scalars['DateTime']>;
  awardedPins: Array<ClassificationsPin>;
  boughtDevices: PorpaginasResult_Device;
  boughtDevicesCount: Scalars['Int'];
  childClassifications: PorpaginasResult_NormalClassification;
  contactInfos: Array<ContactInfo>;
  created: Scalars['DateTime'];
  customType?: Maybe<ClassificationCustomType>;
  deleted?: Maybe<Scalars['DateTime']>;
  devices: PorpaginasResult_Device;
  devicesSales: Array<DevicesSale>;
  devicesSalesCount: Scalars['Int'];
  deviceTypeCounts: Array<DatedEntryData>;
  external_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  metadata?: Maybe<ClassificationMetadata>;
  modified: Scalars['DateTime'];
  /**
   * Get type of next typed classification.
   * If type of this Entity is 'custom' the type of the next parent with a type other than 'custom' will be returned.
   * Otherwise, the type of this Entity is returned
   */
  nextTypedClassificationType: ClassificationTypeEnum;
  /**
   * Get parent_classification field.
   * Strange Function name is for backwards compatibility
   */
  parent_classification?: Maybe<NormalClassification>;
  parent_id?: Maybe<Scalars['ID']>;
  /** Get First parentClassification that matches conditions */
  parentClassification?: Maybe<NormalClassification>;
  parentClassifications: Array<NormalClassification>;
  pins: PorpaginasResult_Pin;
  points: PorpaginasResult_Point;
  purchases: PorpaginasResult_Sale;
  quotas: PorpaginasResult_Quota;
  ratingdatas: PorpaginasResult_Ratingdata;
  /**
   * The total sale count of classification (of sales and Ratingdatas table)
   * This field only has data when returned from getTopImporters.
   */
  saleCount: Scalars['Int'];
  sales: PorpaginasResult_Sale;
  soldDevices: PorpaginasResult_Device;
  stars: PorpaginasResult_Star;
  title: Scalars['String'];
  type: ClassificationTypeEnum;
  users: Array<User>;
  usersPaginated: PorpaginasResult_User;
};


export type DeviceCountClassificationDevicesSalesArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type DeviceCountClassificationDevicesSalesCountArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type DeviceCountClassificationParentClassificationArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type DeviceCountClassificationParentClassificationsArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type DeviceCountClassificationPurchasesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};


export type DeviceCountClassificationRatingdatasArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type DeviceCountClassificationSalesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};

export enum DeviceCountClassificationSorterFields {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DeletedAsc = 'DELETED_ASC',
  DeletedDesc = 'DELETED_DESC',
  DeviceCountAsc = 'DEVICE_COUNT_ASC',
  DeviceCountDesc = 'DEVICE_COUNT_DESC',
  FreeCountAsc = 'FREE_COUNT_ASC',
  FreeCountDesc = 'FREE_COUNT_DESC',
  ModifiedAsc = 'MODIFIED_ASC',
  ModifiedDesc = 'MODIFIED_DESC',
  ParentTitleAsc = 'PARENT_TITLE_ASC',
  ParentTitleDesc = 'PARENT_TITLE_DESC',
  SalesCountAsc = 'SALES_COUNT_ASC',
  SalesCountDesc = 'SALES_COUNT_DESC',
  StarCountAsc = 'STAR_COUNT_ASC',
  StarCountDesc = 'STAR_COUNT_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  WarrantyCountAsc = 'WARRANTY_COUNT_ASC',
  WarrantyCountDesc = 'WARRANTY_COUNT_DESC'
}

export type DeviceCountClassificationSorterInput = {
  dates?: InputMaybe<Array<Scalars['DateTime']>>;
  fields: Array<DeviceCountClassificationSorterFields>;
};

export type DeviceFilterInput = {
  devicetype?: InputMaybe<IdMatcherInput>;
  ignoreSellableForIds?: InputMaybe<Array<Scalars['ID']>>;
  imported?: InputMaybe<Scalars['DateTime']>;
  importer?: InputMaybe<Scalars['ID']>;
  sellable?: InputMaybe<Scalars['Boolean']>;
  serial?: InputMaybe<StringMatcherInput>;
  sold_by?: InputMaybe<Scalars['ID']>;
  sold_to?: InputMaybe<Scalars['ID']>;
};

export type DeviceInfoInput = {
  device_id?: InputMaybe<Scalars['ID']>;
  devicetype_id: Scalars['ID'];
};

export enum DeviceSaleReasonEnum {
  ChangeDate = 'CHANGE_DATE',
  Goodwill = 'GOODWILL',
  LateMistake = 'LATE_MISTAKE',
  Mistake = 'MISTAKE',
  Purchase = 'PURCHASE',
  Return = 'RETURN',
  TradeIn = 'TRADE_IN',
  WarrantyExchange = 'WARRANTY_EXCHANGE',
  WarrantyTakeBack = 'WARRANTY_TAKE_BACK'
}

export type DeviceSerialInfo = {
  __typename?: 'DeviceSerialInfo';
  endSerial: DestructuredSerial;
  existing: Array<Scalars['String']>;
  generated: Array<Scalars['String']>;
  startSerial: DestructuredSerial;
};

export enum DeviceSorterFields {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DeletedAsc = 'DELETED_ASC',
  DeletedDesc = 'DELETED_DESC',
  ImportedAsc = 'IMPORTED_ASC',
  ImportedDesc = 'IMPORTED_DESC',
  ModifiedAsc = 'MODIFIED_ASC',
  ModifiedDesc = 'MODIFIED_DESC',
  SerialAsc = 'SERIAL_ASC',
  SerialDesc = 'SERIAL_DESC',
  SoldAsc = 'SOLD_ASC',
  SoldDesc = 'SOLD_DESC'
}

export type DeviceSorterInput = {
  fields: Array<DeviceSorterFields>;
};

export type DevicesSale = {
  __typename?: 'DevicesSale';
  change_date: Scalars['DateTime'];
  classification: ClassificationInterface;
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  device: Device;
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  reason: DeviceSaleReasonEnum;
  sale?: Maybe<Sale>;
  storno?: Maybe<StornoStruct>;
};

export type DevicesSaleFilterInput = {
  consultant_id?: InputMaybe<Scalars['ID']>;
  customer_id?: InputMaybe<Scalars['ID']>;
  from?: InputMaybe<Scalars['FrozenTime']>;
  reason?: InputMaybe<DeviceSaleReasonEnum>;
  serial?: InputMaybe<Scalars['String']>;
  storno?: InputMaybe<Scalars['Boolean']>;
  until?: InputMaybe<Scalars['FrozenTime']>;
};

export enum DevicesSaleSorterFields {
  ChangeDateAsc = 'CHANGE_DATE_ASC',
  ChangeDateDesc = 'CHANGE_DATE_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  ModifiedAsc = 'MODIFIED_ASC',
  ModifiedDesc = 'MODIFIED_DESC',
  SerialAsc = 'SERIAL_ASC',
  SerialDesc = 'SERIAL_DESC'
}

export type DevicesSaleSorterInput = {
  fields: Array<DevicesSaleSorterFields>;
};

export type Devicetype = {
  __typename?: 'Devicetype';
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  devices: PorpaginasResult_Device;
  devices_count: Scalars['Int'];
  has_serial: Scalars['Boolean'];
  id: Scalars['ID'];
  importer_serial: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  ranking: Scalars['Boolean'];
  ranking_end?: Maybe<Scalars['DateTime']>;
  ranking_start?: Maybe<Scalars['DateTime']>;
  sort?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  type_serial?: Maybe<Scalars['String']>;
};

export type DevicetypeFilterInput = {
  onlyAvailable?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum DevicetypesSorterFields {
  RankingAsc = 'RANKING_ASC',
  RankingDesc = 'RANKING_DESC',
  Sort = 'SORT',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type DevicetypesSorterInput = {
  fields: Array<DevicetypesSorterFields>;
};

export type EntryData = {
  __typename?: 'EntryData';
  bought: Scalars['Int'];
  free: Scalars['Int'];
  purchased: Scalars['Int'];
  quotaTarget: Scalars['Int'];
  sold: Scalars['Int'];
  warranty: Scalars['Int'];
};

export type EntryDataInput = {
  bought?: InputMaybe<Scalars['Int']>;
  free?: InputMaybe<Scalars['Int']>;
  quotaTarget?: InputMaybe<Scalars['Int']>;
  sold?: InputMaybe<Scalars['Int']>;
  warranty?: InputMaybe<Scalars['Int']>;
};

export type Event = {
  __typename?: 'Event';
  content: Scalars['String'];
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  end_date: Scalars['DateTime'];
  header?: Maybe<File>;
  id: Scalars['String'];
  location: Scalars['String'];
  modified: Scalars['DateTime'];
  notification_start?: Maybe<Scalars['DateTime']>;
  registration_until: Scalars['DateTime'];
  start_date: Scalars['DateTime'];
  title: Scalars['String'];
};

export type EventFilterInput = {
  from?: InputMaybe<Scalars['FrozenTime']>;
  includePast?: InputMaybe<Scalars['Boolean']>;
  includeStarted?: InputMaybe<Scalars['Boolean']>;
  registration_open?: InputMaybe<Scalars['Boolean']>;
  should_notify?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['FrozenTime']>;
};

export type EventRegistration = {
  __typename?: 'EventRegistration';
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  event: Event;
  first_name: Scalars['String'];
  id: Scalars['String'];
  importer: ClassificationInterface;
  last_name: Scalars['String'];
  modified: Scalars['DateTime'];
  position: EventRegistrationPosition;
};

export type EventRegistrationFilterInput = {
  event_id?: InputMaybe<Scalars['ID']>;
  first_name?: InputMaybe<Scalars['String']>;
  importer_id?: InputMaybe<Scalars['ID']>;
  importer_title?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<EventRegistrationPosition>;
  registered_after?: InputMaybe<Scalars['FrozenTime']>;
  registered_before?: InputMaybe<Scalars['FrozenTime']>;
};

export enum EventRegistrationPosition {
  Consultant = 'CONSULTANT',
  Distributor = 'DISTRIBUTOR',
  Organization = 'ORGANIZATION',
  Telemarketing = 'TELEMARKETING'
}

export enum EventRegistrationSorterFields {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DeletedAsc = 'DELETED_ASC',
  DeletedDesc = 'DELETED_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  ImporterAsc = 'IMPORTER_ASC',
  ImporterDesc = 'IMPORTER_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  ModifiedAsc = 'MODIFIED_ASC',
  ModifiedDesc = 'MODIFIED_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC'
}

export type EventRegistrationSorterInput = {
  fields: Array<EventRegistrationSorterFields>;
};

export enum EventSorterFields {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DeletedAsc = 'DELETED_ASC',
  DeletedDesc = 'DELETED_DESC',
  EndAsc = 'END_ASC',
  EndDesc = 'END_DESC',
  ModifiedAsc = 'MODIFIED_ASC',
  ModifiedDesc = 'MODIFIED_DESC',
  RegistrationUntilAsc = 'REGISTRATION_UNTIL_ASC',
  RegistrationUntilDesc = 'REGISTRATION_UNTIL_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type EventSorterInput = {
  fields: Array<EventSorterFields>;
};

export type File = {
  __typename?: 'File';
  created: Scalars['DateTime'];
  display_filename: Scalars['String'];
  extension?: Maybe<Scalars['String']>;
  filenameWithExt: Scalars['String'];
  filePath: Scalars['String'];
  filesize: Scalars['Int'];
  humanFilesize: Scalars['String'];
  id: Scalars['String'];
  mime_type: Scalars['String'];
  url: Scalars['String'];
};

export enum GenderEnum {
  Company = 'COMPANY',
  Diverse = 'DIVERSE',
  Family = 'FAMILY',
  Female = 'FEMALE',
  Male = 'MALE',
  Mrmr = 'MRMR',
  Mrmrs = 'MRMRS',
  Mrsmr = 'MRSMR',
  Mrsmrs = 'MRSMRS',
  Undisclosed = 'UNDISCLOSED'
}

export type GeneratedFile = {
  __typename?: 'GeneratedFile';
  file: File;
  id: Scalars['ID'];
  jobId: Scalars['ID'];
};

export type IdMatcherInput = {
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  neq?: InputMaybe<Scalars['ID']>;
  nin?: InputMaybe<Array<Scalars['ID']>>;
};

export type ImportDiffChildren = {
  __typename?: 'ImportDiffChildren';
  externalId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type ImportDiffData = {
  __typename?: 'ImportDiffData';
  children: Array<ImportDiffChildren>;
  classification: ClassificationInterface;
  dbSales: Array<SaleStruct>;
  dbSalesCount: Scalars['Int'];
  xmlSales: Array<SaleStruct>;
  xmlSalesCount: Scalars['Int'];
};

export type ImporterCodeFilterInput = {
  code?: InputMaybe<Scalars['String']>;
  importerId?: InputMaybe<Scalars['ID']>;
  importerTitle?: InputMaybe<Scalars['String']>;
};

export enum ImporterCodesSorterFields {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DeletedAsc = 'DELETED_ASC',
  DeletedDesc = 'DELETED_DESC',
  ImporterTitleAsc = 'IMPORTER_TITLE_ASC',
  ImporterTitleDesc = 'IMPORTER_TITLE_DESC',
  ModifiedAsc = 'MODIFIED_ASC',
  ModifiedDesc = 'MODIFIED_DESC'
}

export type ImporterCodesSorterInput = {
  fields: Array<ImporterCodesSorterFields>;
};

export type IntervalCalculationEntry = CalculationEntryInterface & {
  __typename?: 'IntervalCalculationEntry';
  data: EntryData;
  dateDiff: DateDiff;
  entries: Array<DatedCalculationEntry>;
  growth: Scalars['Int'];
  quota: Scalars['Int'];
  quotaTarget: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAddress: Address;
  addClassification: NormalClassification;
  addClassificationsBulk: Array<NormalClassification>;
  addClassificationsPin: ClassificationsPin;
  addContactInfo: ContactInfo;
  addDeviceToSale: Sale;
  addPin: Pin;
  addQuotas: Array<Quota>;
  addRatingdatas: Array<Ratingdata>;
  addUser: User;
  archiveClassification: NormalClassification;
  championsAsExcel: File;
  changePassword: Scalars['Boolean'];
  compareImportFileExcel: GeneratedFile;
  compareRankingExcel: File;
  convertSaleToSerial: Scalars['Boolean'];
  createAdmin: User;
  /** Create a new ClassificationCode */
  createClassificationCode: ClassificationCode;
  createCustomType: ClassificationCustomType;
  deleteAddress: Scalars['Boolean'];
  deleteAdmin: Scalars['ID'];
  deleteArticle: Scalars['ID'];
  /** Delete Classification */
  deleteClassification: Scalars['Boolean'];
  /** Update a ClassificationCode */
  deleteClassificationCode: Scalars['ID'];
  deleteClassificationsPin: Scalars['ID'];
  deleteContactInfo: Scalars['Boolean'];
  deleteCustomType: Scalars['Boolean'];
  /** Update a ClassificationCode */
  deleteDevicetype: Scalars['ID'];
  deleteEvent: Scalars['ID'];
  deleteEventRegistration: Scalars['ID'];
  deletePin: Scalars['Boolean'];
  deleteRankingLock: RankingLock;
  deleteSale: Scalars['ID'];
  deleteShipment: Scalars['ID'];
  deleteUser: Scalars['ID'];
  devicesPerTypeAndImporterExcel: File;
  dismissEventNotifications: Scalars['Boolean'];
  editAdmin: User;
  editClassificationsPin: ClassificationsPin;
  eventRegistrationsExcel: File;
  generatePins: Scalars['ID'];
  /** Determine the top importer for given month (or year) and persist it */
  generateTopImporter: Array<Star>;
  growthRankingExcel: File;
  markArticleAsRead: Article;
  pinsExcel: File;
  pointsRankingExcel: File;
  rawRankingExcel: File;
  removeDeviceFromSale: Sale;
  saveArticle: Article;
  saveDevicetype: Devicetype;
  saveEvent: Event;
  saveEventRegistration: EventRegistration;
  saveRankingLock: RankingLock;
  saveSale: Sale;
  saveSalesBulk: Array<Sale>;
  saveShipment: Shipment;
  updateAddress: Address;
  updateArticle: Article;
  /** Edit method */
  updateClassification: NormalClassification;
  /** Update a ClassificationCode */
  updateClassificationCode: ClassificationCode;
  updateClassificationsBulk: Scalars['Boolean'];
  updateContactInfo: ContactInfo;
  updateCustomType: ClassificationCustomType;
  updateDevicetype: Devicetype;
  updateEvent: Event;
  updateEventRegistration: EventRegistration;
  updatePin: Pin;
  updateProfile: User;
  updateSale: Sale;
  updateShipment: Shipment;
  updateUser: User;
  volumeRankingExcel: File;
};


export type MutationAddAddressArgs = {
  address: AddressInput;
  classification_id: Scalars['ID'];
};


export type MutationAddClassificationArgs = {
  addresses?: InputMaybe<Array<AddressInput>>;
  addUser?: InputMaybe<UserInput>;
  contactInfos?: InputMaybe<Array<ContactInfoInput>>;
  custom_type_id?: InputMaybe<Scalars['ID']>;
  external_id?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<ClassificationMetadataInput>;
  parent_id?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
  type: ClassificationTypeEnum;
};


export type MutationAddClassificationsBulkArgs = {
  classifications: Array<AddStructure>;
};


export type MutationAddClassificationsPinArgs = {
  pin: CreateClassificationsPin;
};


export type MutationAddContactInfoArgs = {
  classification_id: Scalars['ID'];
  contact_info: ContactInfoInput;
};


export type MutationAddDeviceToSaleArgs = {
  classification_id: Scalars['ID'];
  date?: InputMaybe<Scalars['DateTime']>;
  deviceInfo: DeviceInfoInput;
  reason?: InputMaybe<DeviceSaleReasonEnum>;
  sale_id: Scalars['ID'];
};


export type MutationAddPinArgs = {
  pin: PinInput;
};


export type MutationAddQuotasArgs = {
  quotas: Array<QuotaInput>;
  type: ClassificationTypeEnum;
};


export type MutationAddRatingdatasArgs = {
  ratingdatas: Array<RatingdataInput>;
  type: ClassificationTypeEnum;
};


export type MutationAddUserArgs = {
  classification_id: Scalars['ID'];
  user: UserInput;
};


export type MutationArchiveClassificationArgs = {
  archived?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
};


export type MutationChampionsAsExcelArgs = {
  end: Scalars['DateTime'];
  maxValue: Scalars['Int'];
  minValue: Scalars['Int'];
  start: Scalars['DateTime'];
  type?: InputMaybe<ClassificationTypeEnum>;
};


export type MutationChangePasswordArgs = {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
};


export type MutationCompareImportFileExcelArgs = {
  classificationId?: InputMaybe<Scalars['ID']>;
  classificationType: ClassificationTypeEnum;
  country: Scalars['String'];
  date: Scalars['DateTime'];
  filename: Scalars['String'];
  skipMatching?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCompareRankingExcelArgs = {
  end: Scalars['DateTime'];
  filter?: InputMaybe<ClassificationFilterInput>;
  interval?: InputMaybe<Scalars['Int']>;
  start: Scalars['DateTime'];
};


export type MutationConvertSaleToSerialArgs = {
  placeholder_device_id: Scalars['ID'];
  sale_id: Scalars['ID'];
  serial_device_id: Scalars['ID'];
};


export type MutationCreateAdminArgs = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  last_name: Scalars['String'];
  role_slug: RoleSlugEnum;
};


export type MutationCreateClassificationCodeArgs = {
  classification_id: Scalars['ID'];
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCustomTypeArgs = {
  customType: CreateCustomType;
};


export type MutationDeleteAddressArgs = {
  addressId: Scalars['ID'];
};


export type MutationDeleteAdminArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteArticleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClassificationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClassificationCodeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClassificationsPinArgs = {
  pin_id: Scalars['ID'];
};


export type MutationDeleteContactInfoArgs = {
  contact_infoId: Scalars['ID'];
};


export type MutationDeleteCustomTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDevicetypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEventRegistrationArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePinArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRankingLockArgs = {
  locked_month: Scalars['DateTime'];
};


export type MutationDeleteSaleArgs = {
  classification_id: Scalars['ID'];
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  reason: DeviceSaleReasonEnum;
};


export type MutationDeleteShipmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  user_id: Scalars['ID'];
};


export type MutationDevicesPerTypeAndImporterExcelArgs = {
  devicetype_id: Scalars['ID'];
  end?: InputMaybe<Scalars['DateTime']>;
  interval?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<DeviceCountClassificationSorterInput>;
  start: Scalars['DateTime'];
};


export type MutationDismissEventNotificationsArgs = {
  id: Scalars['ID'];
};


export type MutationEditAdminArgs = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  last_name: Scalars['String'];
  role_slug: RoleSlugEnum;
};


export type MutationEditClassificationsPinArgs = {
  pin: UpdateClassificationsPin;
};


export type MutationEventRegistrationsExcelArgs = {
  filter?: InputMaybe<EventRegistrationFilterInput>;
  sorter?: InputMaybe<EventRegistrationSorterInput>;
};


export type MutationGeneratePinsArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type MutationGenerateTopImporterArgs = {
  date: Scalars['DateTime'];
  regeneration?: InputMaybe<Scalars['Boolean']>;
  yearly?: InputMaybe<Scalars['Boolean']>;
};


export type MutationGrowthRankingExcelArgs = {
  date: Scalars['DateTime'];
  type: ClassificationTypeEnum;
};


export type MutationMarkArticleAsReadArgs = {
  articleId: Scalars['ID'];
};


export type MutationPinsExcelArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  filter?: InputMaybe<PinFilterInput>;
};


export type MutationPointsRankingExcelArgs = {
  date: Scalars['DateTime'];
  fullYear?: InputMaybe<Scalars['Boolean']>;
  showUnfinished?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<ClassificationTypeEnum>;
};


export type MutationRawRankingExcelArgs = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
  type: ClassificationTypeEnum;
};


export type MutationRemoveDeviceFromSaleArgs = {
  classification_id: Scalars['ID'];
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  reason: DeviceSaleReasonEnum;
};


export type MutationSaveArticleArgs = {
  article: CreateArticle;
};


export type MutationSaveDevicetypeArgs = {
  devicetype: CreateDeviceType;
};


export type MutationSaveEventArgs = {
  event: CreateEvent;
};


export type MutationSaveEventRegistrationArgs = {
  registration: CreateEventRegistration;
};


export type MutationSaveRankingLockArgs = {
  locked_month: Scalars['DateTime'];
  start: Scalars['DateTime'];
};


export type MutationSaveSaleArgs = {
  sale: SaleInput;
};


export type MutationSaveSalesBulkArgs = {
  sales: Array<SaleInput>;
};


export type MutationSaveShipmentArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  classification_id: Scalars['ID'];
  date: Scalars['DateTime'];
  devicetype_id: Scalars['ID'];
  free: Scalars['Int'];
  serial_end?: InputMaybe<Scalars['String']>;
  serial_start?: InputMaybe<Scalars['String']>;
  warranty: Scalars['Int'];
};


export type MutationUpdateAddressArgs = {
  address: AddressInput;
  addressId: Scalars['ID'];
};


export type MutationUpdateArticleArgs = {
  article?: InputMaybe<UpdateArticle>;
};


export type MutationUpdateClassificationArgs = {
  addresses?: InputMaybe<Array<AddressInput>>;
  contactInfos?: InputMaybe<Array<ContactInfoInput>>;
  custom_type_id?: InputMaybe<Scalars['ID']>;
  external_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  metadata?: InputMaybe<ClassificationMetadataInput>;
  parent_id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ClassificationTypeEnum>;
};


export type MutationUpdateClassificationCodeArgs = {
  code: ClassificationCodeInput;
};


export type MutationUpdateClassificationsBulkArgs = {
  classifications: Array<UpdateStructure>;
};


export type MutationUpdateContactInfoArgs = {
  contact_info: UpdateContactInfoInput;
};


export type MutationUpdateCustomTypeArgs = {
  customType: UpdateCustomType;
};


export type MutationUpdateDevicetypeArgs = {
  devicetype?: InputMaybe<UpdateDeviceType>;
};


export type MutationUpdateEventArgs = {
  event: UpdateEvent;
};


export type MutationUpdateEventRegistrationArgs = {
  registration: UpdateEventRegistration;
};


export type MutationUpdatePinArgs = {
  pin?: InputMaybe<UpdatePinInput>;
};


export type MutationUpdateProfileArgs = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateSaleArgs = {
  sale?: InputMaybe<UpdateSaleInput>;
  updateDifferingDates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateShipmentArgs = {
  shipment: ShipmentInput;
};


export type MutationUpdateUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  user_id: Scalars['ID'];
};


export type MutationVolumeRankingExcelArgs = {
  date: Scalars['DateTime'];
  fullYear?: InputMaybe<Scalars['Boolean']>;
  type: ClassificationTypeEnum;
};

export type NormalClassification = ClassificationInterface & {
  __typename?: 'NormalClassification';
  addresses: Array<Address>;
  allowedSubTypes: Array<ClassificationTypeEnum>;
  archived?: Maybe<Scalars['DateTime']>;
  awardedPins: Array<ClassificationsPin>;
  boughtDevices: PorpaginasResult_Device;
  boughtDevicesCount: Scalars['Int'];
  childClassifications: PorpaginasResult_NormalClassification;
  contactInfos: Array<ContactInfo>;
  created: Scalars['DateTime'];
  customType?: Maybe<ClassificationCustomType>;
  deleted?: Maybe<Scalars['DateTime']>;
  devices: PorpaginasResult_Device;
  devicesSales: Array<DevicesSale>;
  devicesSalesCount: Scalars['Int'];
  external_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  metadata?: Maybe<ClassificationMetadata>;
  modified: Scalars['DateTime'];
  /**
   * Get type of next typed classification.
   * If type of this Entity is 'custom' the type of the next parent with a type other than 'custom' will be returned.
   * Otherwise, the type of this Entity is returned
   */
  nextTypedClassificationType: ClassificationTypeEnum;
  /**
   * Get parent_classification field.
   * Strange Function name is for backwards compatibility
   */
  parent_classification?: Maybe<NormalClassification>;
  parent_id?: Maybe<Scalars['ID']>;
  /** Get First parentClassification that matches conditions */
  parentClassification?: Maybe<NormalClassification>;
  parentClassifications: Array<NormalClassification>;
  pins: PorpaginasResult_Pin;
  points: PorpaginasResult_Point;
  purchases: PorpaginasResult_Sale;
  quotas: PorpaginasResult_Quota;
  ratingdatas: PorpaginasResult_Ratingdata;
  /**
   * The total sale count of classification (of sales and Ratingdatas table)
   * This field only has data when returned from getTopImporters.
   */
  saleCount: Scalars['Int'];
  sales: PorpaginasResult_Sale;
  soldDevices: PorpaginasResult_Device;
  stars: PorpaginasResult_Star;
  title: Scalars['String'];
  type: ClassificationTypeEnum;
  users: Array<User>;
  usersPaginated: PorpaginasResult_User;
};


export type NormalClassificationDevicesSalesArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type NormalClassificationDevicesSalesCountArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
};


export type NormalClassificationParentClassificationArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type NormalClassificationParentClassificationsArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type NormalClassificationPurchasesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};


export type NormalClassificationRatingdatasArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type NormalClassificationSalesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
};

export type Pin = {
  __typename?: 'Pin';
  classificationsPins: Array<ClassificationsPin>;
  classificationType: PinTypeEnum;
  created: Scalars['FrozenTime'];
  file?: Maybe<File>;
  id: Scalars['ID'];
  modified: Scalars['FrozenTime'];
  pinrules: Array<Pinrule>;
  slug: Scalars['String'];
  sort_by: Scalars['Int'];
  title: Scalars['String'];
};


export type PinClassificationsPinsArgs = {
  date: Scalars['DateTime'];
  type?: InputMaybe<ClassificationTypeEnum>;
};

export type PinFilterInput = {
  not_awarded_to_classification_id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<PinTypeEnum>>;
};

export type PinInput = {
  classificationType?: InputMaybe<PinTypeEnum>;
  file_id?: InputMaybe<Scalars['ID']>;
  pinrules?: InputMaybe<Array<PinruleInput>>;
  title: Scalars['String'];
};

export type Pinrule = {
  __typename?: 'Pinrule';
  condition_field: PinruleFieldEnum;
  condition_type: PinruleTypeEnum;
  condition_value: Scalars['String'];
  continuous: Scalars['Boolean'];
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  streak: Scalars['Int'];
};

export enum PinruleFieldEnum {
  Bought = 'BOUGHT',
  Free = 'FREE',
  ImporterType = 'IMPORTER_TYPE',
  Purchased = 'PURCHASED',
  Sold = 'SOLD',
  Warranty = 'WARRANTY'
}

export type PinruleInput = {
  condition_field: PinruleFieldEnum;
  condition_type: PinruleTypeEnum;
  condition_value: Scalars['String'];
  continuous: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  streak: Scalars['Int'];
};

export enum PinruleTypeEnum {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  In = 'IN',
  Lt = 'LT',
  Lte = 'LTE'
}

export enum PinTypeEnum {
  Consultant = 'CONSULTANT',
  Distributor = 'DISTRIBUTOR',
  General = 'GENERAL',
  Importer = 'IMPORTER',
  Organization = 'ORGANIZATION'
}

export type Point = {
  __typename?: 'Point';
  consultant: NormalClassification;
  created: Scalars['DateTime'];
  date: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  quota: Scalars['Int'];
  type: RankTypeEnum;
};

export type PorpaginasResult_Article = {
  __typename?: 'PorpaginasResult_Article';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Article>;
};


export type PorpaginasResult_ArticleItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_ArticleClassification = {
  __typename?: 'PorpaginasResult_ArticleClassification';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<ArticleClassification>;
};


export type PorpaginasResult_ArticleClassificationItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_CalculatedClassification = {
  __typename?: 'PorpaginasResult_CalculatedClassification';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<CalculatedClassification>;
};


export type PorpaginasResult_CalculatedClassificationItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Champion = {
  __typename?: 'PorpaginasResult_Champion';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Champion>;
};


export type PorpaginasResult_ChampionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_ClassificationCode = {
  __typename?: 'PorpaginasResult_ClassificationCode';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<ClassificationCode>;
};


export type PorpaginasResult_ClassificationCodeItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_ClassificationCustomType = {
  __typename?: 'PorpaginasResult_ClassificationCustomType';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<ClassificationCustomType>;
};


export type PorpaginasResult_ClassificationCustomTypeItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Device = {
  __typename?: 'PorpaginasResult_Device';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Device>;
};


export type PorpaginasResult_DeviceItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_DeviceCountClassification = {
  __typename?: 'PorpaginasResult_DeviceCountClassification';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<DeviceCountClassification>;
};


export type PorpaginasResult_DeviceCountClassificationItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_DevicesSale = {
  __typename?: 'PorpaginasResult_DevicesSale';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<DevicesSale>;
};


export type PorpaginasResult_DevicesSaleItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Devicetype = {
  __typename?: 'PorpaginasResult_Devicetype';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Devicetype>;
};


export type PorpaginasResult_DevicetypeItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Event = {
  __typename?: 'PorpaginasResult_Event';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Event>;
};


export type PorpaginasResult_EventItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_EventRegistration = {
  __typename?: 'PorpaginasResult_EventRegistration';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<EventRegistration>;
};


export type PorpaginasResult_EventRegistrationItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_NormalClassification = {
  __typename?: 'PorpaginasResult_NormalClassification';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<NormalClassification>;
};


export type PorpaginasResult_NormalClassificationItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Pin = {
  __typename?: 'PorpaginasResult_Pin';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Pin>;
};


export type PorpaginasResult_PinItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Point = {
  __typename?: 'PorpaginasResult_Point';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Point>;
};


export type PorpaginasResult_PointItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Quota = {
  __typename?: 'PorpaginasResult_Quota';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Quota>;
};


export type PorpaginasResult_QuotaItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_RankedClassification = {
  __typename?: 'PorpaginasResult_RankedClassification';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<RankedClassification>;
};


export type PorpaginasResult_RankedClassificationItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_RankingLock = {
  __typename?: 'PorpaginasResult_RankingLock';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<RankingLock>;
};


export type PorpaginasResult_RankingLockItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Ratingdata = {
  __typename?: 'PorpaginasResult_Ratingdata';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Ratingdata>;
};


export type PorpaginasResult_RatingdataItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Sale = {
  __typename?: 'PorpaginasResult_Sale';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Sale>;
};


export type PorpaginasResult_SaleItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Shipment = {
  __typename?: 'PorpaginasResult_Shipment';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Shipment>;
};


export type PorpaginasResult_ShipmentItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_Star = {
  __typename?: 'PorpaginasResult_Star';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<Star>;
};


export type PorpaginasResult_StarItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PorpaginasResult_User = {
  __typename?: 'PorpaginasResult_User';
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
  items: Array<User>;
};


export type PorpaginasResult_UserItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  activeUserCount: Array<DatedInt>;
  activeUsers: Array<User>;
  article: Article;
  articles: PorpaginasResult_Article;
  articleViews: PorpaginasResult_ArticleClassification;
  avgRequestProcessingTime: Array<DatedInt>;
  avgRequestsPerSecond: Array<DatedInt>;
  champions: PorpaginasResult_Champion;
  checkMailAvailable: Scalars['Boolean'];
  checkSerial: Scalars['Boolean'];
  classification: NormalClassification;
  /** Get all Classification Codes */
  classificationCodes: PorpaginasResult_ClassificationCode;
  classifications: PorpaginasResult_NormalClassification;
  combinedData: PorpaginasResult_RankedClassification;
  compareImportFile: Array<ImportDiffData>;
  compareRanking: Array<CompareClassification>;
  countClassifications: Scalars['Int'];
  currentDate: Scalars['DateTime'];
  currentYear: Scalars['DateTime'];
  customType: ClassificationCustomType;
  customTypes: PorpaginasResult_ClassificationCustomType;
  device: Device;
  devices: PorpaginasResult_Device;
  devicesPerMonth: Array<DatedEntryData>;
  devicesPerTypeAndImporter: PorpaginasResult_DeviceCountClassification;
  devicesSales: PorpaginasResult_DevicesSale;
  devicetypes: PorpaginasResult_Devicetype;
  event: Event;
  eventRegistration: EventRegistration;
  eventRegistrations: PorpaginasResult_EventRegistration;
  events: PorpaginasResult_Event;
  /**
   * Get File Info
   * Due to limitations of GraphQL, this method cannot be used to get the files contents.
   * Please use the REST-Endpoint to fetch files.
   */
  file: File;
  firstDate: Scalars['DateTime'];
  firstYear: Scalars['DateTime'];
  generateGrowthForData: Array<RankedClassification>;
  generateVolumeAndGrowthForData: Array<RankedClassification>;
  generateVolumeForData: Array<RankedClassification>;
  growthRanking: Array<RankedClassification>;
  identity: User;
  importFiles: Array<Scalars['String']>;
  internalRanking: Array<SummedClassification>;
  jobs: Array<QueuedJob>;
  nestedClassifications: PorpaginasResult_NormalClassification;
  nextDate: Scalars['DateTime'];
  nextYear: Scalars['DateTime'];
  pin: Pin;
  pins: PorpaginasResult_Pin;
  pointsRanking: PorpaginasResult_RankedClassification;
  quantityGraph: PorpaginasResult_CalculatedClassification;
  quotas: PorpaginasResult_Quota;
  rankingLock: RankingLock;
  rankingLockForStart: RankingLock;
  rankingLocks: PorpaginasResult_RankingLock;
  rawRanking: PorpaginasResult_CalculatedClassification;
  sale: Sale;
  sales: PorpaginasResult_Sale;
  salesPerMonth: Array<DatedInt>;
  shipment: Shipment;
  shipments: PorpaginasResult_Shipment;
  /** @deprecated This function is just an alias of the classifications query with a filter for type IMPORTER. */
  showStarOverview: PorpaginasResult_NormalClassification;
  showStars: PorpaginasResult_Star;
  /**
   * Get monthly or yearly Top importers
   * @\TheCodingMachine\GraphQLite\Annotations\Query()
   */
  showTopImporters: PorpaginasResult_Star;
  topPerformers: PorpaginasResult_NormalClassification;
  totalDevices: Scalars['Int'];
  totalSales: Scalars['Int'];
  user: User;
  users: PorpaginasResult_User;
  validateSerialRange: DeviceSerialInfo;
  volumeRanking: PorpaginasResult_RankedClassification;
};


export type QueryActiveUserCountArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryActiveUsersArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type QueryArticleArgs = {
  id: Scalars['ID'];
};


export type QueryArticlesArgs = {
  filter?: InputMaybe<ArticleFilterInput>;
  sorter?: InputMaybe<ArticleSorterInput>;
};


export type QueryArticleViewsArgs = {
  articleId: Scalars['ID'];
};


export type QueryAvgRequestProcessingTimeArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryAvgRequestsPerSecondArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryChampionsArgs = {
  end: Scalars['DateTime'];
  maxValue: Scalars['Int'];
  minValue: Scalars['Int'];
  start: Scalars['DateTime'];
  type?: InputMaybe<ClassificationTypeEnum>;
};


export type QueryCheckMailAvailableArgs = {
  email: Scalars['String'];
  except?: InputMaybe<Scalars['ID']>;
};


export type QueryCheckSerialArgs = {
  devicetype_id: Scalars['ID'];
  importer_id?: InputMaybe<Scalars['ID']>;
  serial?: InputMaybe<Scalars['String']>;
};


export type QueryClassificationArgs = {
  id: Scalars['ID'];
};


export type QueryClassificationCodesArgs = {
  filter?: InputMaybe<ImporterCodeFilterInput>;
  sorter?: InputMaybe<ImporterCodesSorterInput>;
};


export type QueryClassificationsArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
  sort?: InputMaybe<ClassificationSorterInput>;
};


export type QueryCombinedDataArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
  month: Scalars['DateTime'];
  type: ClassificationTypeEnum;
};


export type QueryCompareImportFileArgs = {
  classificationId?: InputMaybe<Scalars['ID']>;
  classificationType: ClassificationTypeEnum;
  country: Scalars['String'];
  date: Scalars['DateTime'];
  filename: Scalars['String'];
};


export type QueryCompareRankingArgs = {
  end: Scalars['DateTime'];
  filter?: InputMaybe<ClassificationFilterInput>;
  interval?: InputMaybe<Scalars['Int']>;
  start: Scalars['DateTime'];
};


export type QueryCountClassificationsArgs = {
  filter?: InputMaybe<ClassificationFilterInput>;
};


export type QueryCustomTypeArgs = {
  id: Scalars['ID'];
};


export type QueryCustomTypesArgs = {
  filter?: InputMaybe<ClassificationCustomTypesFilterInput>;
};


export type QueryDeviceArgs = {
  id: Scalars['ID'];
};


export type QueryDevicesArgs = {
  filter?: InputMaybe<DeviceFilterInput>;
  sorter?: InputMaybe<DeviceSorterInput>;
};


export type QueryDevicesPerMonthArgs = {
  classification_id?: InputMaybe<Scalars['ID']>;
  devicetype_id?: InputMaybe<Scalars['ID']>;
  endRaw?: InputMaybe<Scalars['DateTime']>;
  monthly?: InputMaybe<Scalars['Boolean']>;
  startRaw?: InputMaybe<Scalars['DateTime']>;
};


export type QueryDevicesPerTypeAndImporterArgs = {
  devicetype_id: Scalars['ID'];
  end?: InputMaybe<Scalars['DateTime']>;
  interval?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<DeviceCountClassificationSorterInput>;
  start: Scalars['DateTime'];
};


export type QueryDevicesSalesArgs = {
  filter?: InputMaybe<DevicesSaleFilterInput>;
  sorter?: InputMaybe<DevicesSaleSorterInput>;
};


export type QueryDevicetypesArgs = {
  filter?: InputMaybe<DevicetypeFilterInput>;
  sorter?: InputMaybe<DevicetypesSorterInput>;
};


export type QueryEventArgs = {
  id: Scalars['ID'];
};


export type QueryEventRegistrationArgs = {
  id: Scalars['ID'];
};


export type QueryEventRegistrationsArgs = {
  filter?: InputMaybe<EventRegistrationFilterInput>;
  sorter?: InputMaybe<EventRegistrationSorterInput>;
};


export type QueryEventsArgs = {
  filter?: InputMaybe<EventFilterInput>;
  sorter?: InputMaybe<EventSorterInput>;
};


export type QueryFileArgs = {
  id: Scalars['ID'];
};


export type QueryGenerateGrowthForDataArgs = {
  date: Scalars['DateTime'];
  importers: Array<CalculatedClassificationInput>;
};


export type QueryGenerateVolumeAndGrowthForDataArgs = {
  date: Scalars['DateTime'];
  importers: Array<CalculatedClassificationInput>;
};


export type QueryGenerateVolumeForDataArgs = {
  date: Scalars['DateTime'];
  importers: Array<CalculatedClassificationInput>;
};


export type QueryGrowthRankingArgs = {
  date: Scalars['DateTime'];
  type: ClassificationTypeEnum;
};


export type QueryInternalRankingArgs = {
  id: Scalars['ID'];
};


export type QueryJobsArgs = {
  jobIds: Array<Scalars['ID']>;
};


export type QueryNestedClassificationsArgs = {
  parent_id?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ClassificationSorterInput>;
};


export type QueryPinArgs = {
  id: Scalars['ID'];
};


export type QueryPinsArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  filter?: InputMaybe<PinFilterInput>;
};


export type QueryPointsRankingArgs = {
  date: Scalars['DateTime'];
  fullYear?: InputMaybe<Scalars['Boolean']>;
  showUnfinished?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<ClassificationTypeEnum>;
};


export type QueryQuotasArgs = {
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type QueryRankingLockArgs = {
  locked_month: Scalars['DateTime'];
};


export type QueryRankingLockForStartArgs = {
  start: Scalars['DateTime'];
};


export type QueryRankingLocksArgs = {
  filter?: InputMaybe<RankingLockFilterInput>;
  sorter?: InputMaybe<RankingLockSorterInput>;
};


export type QueryRawRankingArgs = {
  end: Scalars['DateTime'];
  filter?: InputMaybe<ClassificationFilterInput>;
  start: Scalars['DateTime'];
  type: ClassificationTypeEnum;
};


export type QuerySaleArgs = {
  id: Scalars['ID'];
};


export type QuerySalesArgs = {
  filter?: InputMaybe<SaleFilterInput>;
  sorter?: InputMaybe<SaleSorterInput>;
};


export type QuerySalesPerMonthArgs = {
  classification_id?: InputMaybe<Scalars['ID']>;
  endRaw?: InputMaybe<Scalars['DateTime']>;
  startRaw?: InputMaybe<Scalars['DateTime']>;
};


export type QueryShipmentArgs = {
  id: Scalars['ID'];
};


export type QueryShipmentsArgs = {
  filter?: InputMaybe<ShipmentsFilterInput>;
  sorter?: InputMaybe<ShipmentsSorterInput>;
};


export type QueryShowStarsArgs = {
  sorter?: InputMaybe<StarsSorterInput>;
};


export type QueryShowTopImportersArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  yearly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTopPerformersArgs = {
  classificationFilter?: InputMaybe<ClassificationFilterInput>;
  dateFilter: DateRangeFilterInput;
};


export type QueryTotalDevicesArgs = {
  classification_id?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  yearly: Scalars['Boolean'];
};


export type QueryTotalSalesArgs = {
  classification_id?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  yearly: Scalars['Boolean'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  usersFilter: UsersFilterInput;
};


export type QueryValidateSerialRangeArgs = {
  devicetype_id: Scalars['ID'];
  endSerial?: InputMaybe<Scalars['String']>;
  importer_id?: InputMaybe<Scalars['ID']>;
  startSerial?: InputMaybe<Scalars['String']>;
};


export type QueryVolumeRankingArgs = {
  date: Scalars['DateTime'];
  fullYear?: InputMaybe<Scalars['Boolean']>;
  type: ClassificationTypeEnum;
};

export type QueuedJob = {
  __typename?: 'QueuedJob';
  completed?: Maybe<Scalars['DateTime']>;
  created: Scalars['DateTime'];
  fetched?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  notBefore?: Maybe<Scalars['DateTime']>;
  progress?: Maybe<Scalars['Float']>;
};

export type Quota = {
  __typename?: 'Quota';
  consultant: NormalClassification;
  created: Scalars['DateTime'];
  date: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  quota: Scalars['Int'];
};

export type QuotaInput = {
  consultant_id: Scalars['ID'];
  date?: InputMaybe<Scalars['DateTime']>;
  quotaTarget: Scalars['Int'];
};

export type RankedClassification = {
  __typename?: 'RankedClassification';
  calculated: CalculationEntryInterface;
  calculatedClassification: CalculatedClassification;
  classification: NormalClassification;
  points: Scalars['Int'];
  pointsDated: Scalars['Int'];
  rank: Scalars['Int'];
  saleEntry?: Maybe<CalculationEntryInterface>;
};


export type RankedClassificationCalculatedArgs = {
  date: Scalars['DateTime'];
};


export type RankedClassificationPointsArgs = {
  type: RankTypeEnum;
};


export type RankedClassificationPointsDatedArgs = {
  date: Scalars['DateTime'];
  type: RankTypeEnum;
};


export type RankedClassificationRankArgs = {
  type: RankTypeEnum;
};


export type RankedClassificationSaleEntryArgs = {
  date: Scalars['DateTime'];
};

export type RankingLock = {
  __typename?: 'RankingLock';
  id: Scalars['String'];
  locked_month: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type RankingLockFilterInput = {
  locked_month_eq?: InputMaybe<Scalars['DateTime']>;
  locked_month_gte?: InputMaybe<Scalars['DateTime']>;
  locked_month_lte?: InputMaybe<Scalars['DateTime']>;
  start_eq?: InputMaybe<Scalars['DateTime']>;
  start_gte?: InputMaybe<Scalars['DateTime']>;
  start_lte?: InputMaybe<Scalars['DateTime']>;
};

export enum RankingLockSorterFields {
  LockedMonthAsc = 'LOCKED_MONTH_ASC',
  LockedMonthDesc = 'LOCKED_MONTH_DESC',
  StartAsc = 'START_ASC',
  StartDesc = 'START_DESC'
}

export type RankingLockSorterInput = {
  fields?: InputMaybe<Array<RankingLockSorterFields>>;
};

export enum RankTypeEnum {
  Growth = 'GROWTH',
  Total = 'TOTAL',
  Volume = 'VOLUME'
}

export type Ratingdata = {
  __typename?: 'Ratingdata';
  bought: Scalars['Int'];
  consultant: NormalClassification;
  created: Scalars['DateTime'];
  date: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  free: Scalars['Int'];
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  sold: Scalars['Int'];
  warranty: Scalars['Int'];
};

export type RatingdataInput = {
  bought: Scalars['Int'];
  consultant_id: Scalars['ID'];
  date: Scalars['DateTime'];
  free: Scalars['Int'];
  sold: Scalars['Int'];
  warranty: Scalars['Int'];
};

export type Role = {
  __typename?: 'Role';
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  slug: RoleSlugEnum;
  title: Scalars['String'];
  users: PorpaginasResult_User;
};

export enum RoleSlugEnum {
  Administrator = 'ADMINISTRATOR',
  Consultant = 'CONSULTANT',
  Customer = 'CUSTOMER',
  Distributor = 'DISTRIBUTOR',
  Importer = 'IMPORTER',
  Organization = 'ORGANIZATION',
  Production = 'PRODUCTION'
}

export type Sale = {
  __typename?: 'Sale';
  consultant: NormalClassification;
  created: Scalars['DateTime'];
  customer: NormalClassification;
  deleted?: Maybe<Scalars['DateTime']>;
  device_count: Scalars['Int'];
  devices: Array<Device>;
  external_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lockedDate?: Maybe<Scalars['DateTime']>;
  modified: Scalars['DateTime'];
  sold: Scalars['DateTime'];
};

export type SaleFilterInput = {
  consultantId?: InputMaybe<Scalars['ID']>;
  consultantTitle?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerTitle?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<IdMatcherInput>;
  importerId?: InputMaybe<Scalars['ID']>;
  importerTitle?: InputMaybe<Scalars['String']>;
  soldAfter?: InputMaybe<Scalars['DateTime']>;
  soldBefore?: InputMaybe<Scalars['DateTime']>;
};

export type SaleInput = {
  consultant_id: Scalars['ID'];
  customer_id: Scalars['ID'];
  device_ids: Array<DeviceInfoInput>;
  external_id?: InputMaybe<Scalars['ID']>;
  online?: InputMaybe<Scalars['Boolean']>;
  sold: Scalars['DateTime'];
};

export enum SaleSorterFields {
  ConsultantTitleAsc = 'CONSULTANT_TITLE_ASC',
  ConsultantTitleDesc = 'CONSULTANT_TITLE_DESC',
  CustomerTitleAsc = 'CUSTOMER_TITLE_ASC',
  CustomerTitleDesc = 'CUSTOMER_TITLE_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DeviceCountAsc = 'DEVICE_COUNT_ASC',
  DeviceCountDesc = 'DEVICE_COUNT_DESC'
}

export type SaleSorterInput = {
  fields: Array<SaleSorterFields>;
};

export type SaleStruct = {
  __typename?: 'SaleStruct';
  brush?: Maybe<Scalars['String']>;
  consultantId: Scalars['String'];
  customerId: Scalars['String'];
  importerId?: Maybe<Scalars['String']>;
  internalId: Scalars['String'];
  serial?: Maybe<Scalars['String']>;
  sold: Scalars['DateTime'];
  stornoReason?: Maybe<DeviceSaleReasonEnum>;
  type: Scalars['String'];
};

export type Shipment = {
  __typename?: 'Shipment';
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  device_count: Scalars['Int'];
  devices: PorpaginasResult_Device;
  devicetype: Devicetype;
  free_count: Scalars['Int'];
  id: Scalars['ID'];
  imported: Scalars['DateTime'];
  importer: NormalClassification;
  maintainer: User;
  modified: Scalars['DateTime'];
  warranty_count: Scalars['Int'];
};

export type ShipmentInput = {
  free_count?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  imported?: InputMaybe<Scalars['DateTime']>;
  warranty_count?: InputMaybe<Scalars['Int']>;
};

export type ShipmentsFilterInput = {
  importedAfter?: InputMaybe<Scalars['DateTime']>;
  importedBefore?: InputMaybe<Scalars['DateTime']>;
  importerId?: InputMaybe<Scalars['ID']>;
  importerTitle?: InputMaybe<Scalars['String']>;
};

export enum ShipmentsSorterFields {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DeviceCountAsc = 'DEVICE_COUNT_ASC',
  DeviceCountDesc = 'DEVICE_COUNT_DESC',
  FreeCountAsc = 'FREE_COUNT_ASC',
  FreeCountDesc = 'FREE_COUNT_DESC',
  ImporterTitleAsc = 'IMPORTER_TITLE_ASC',
  ImporterTitleDesc = 'IMPORTER_TITLE_DESC',
  WarrantyCountAsc = 'WARRANTY_COUNT_ASC',
  WarrantyCountDesc = 'WARRANTY_COUNT_DESC'
}

export type ShipmentsSorterInput = {
  fields: Array<ShipmentsSorterFields>;
};

export type Star = {
  __typename?: 'Star';
  consultant: NormalClassification;
  created: Scalars['DateTime'];
  date: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified: Scalars['DateTime'];
  type: Scalars['String'];
};

export enum StarSorterFields {
  ClassificationAsc = 'CLASSIFICATION_ASC',
  ClassificationDesc = 'CLASSIFICATION_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  ParentClassificationAsc = 'PARENT_CLASSIFICATION_ASC',
  ParentClassificationDesc = 'PARENT_CLASSIFICATION_DESC'
}

export type StarsSorterInput = {
  fields: Array<StarSorterFields>;
};

export type StornoStruct = {
  __typename?: 'StornoStruct';
  date: Scalars['FrozenTime'];
  reason: DeviceSaleReasonEnum;
};

export type StringMatcherInput = {
  /** Match if Entry contains string */
  contains?: InputMaybe<Scalars['String']>;
  /** Match if Entry ends with string */
  endsWith?: InputMaybe<Scalars['String']>;
  /** Match if Entry equals string */
  eq?: InputMaybe<Scalars['String']>;
  /** Match if Entry is in list */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Match if Entry does not equal string */
  neq?: InputMaybe<Scalars['String']>;
  /** Match if Entry is not in list */
  nin?: InputMaybe<Array<Scalars['String']>>;
  null?: InputMaybe<Scalars['Boolean']>;
  /** Match if Entry starts with string */
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** A placeholder query used by thecodingmachine/graphqlite when there are no declared subscriptions. */
  dummySubscription?: Maybe<Scalars['String']>;
};

export type SummedClassification = {
  __typename?: 'SummedClassification';
  calculations: Array<DatedCalculationEntry>;
  classification: NormalClassification;
};

export type UpdateArticle = {
  content: Scalars['String'];
  files: Array<ArticlesFileInput>;
  id: Scalars['ID'];
  published: Scalars['DateTime'];
  title: Scalars['String'];
};

export type UpdateClassificationsPin = {
  date: Scalars['FrozenDate'];
  id: Scalars['ID'];
};

export type UpdateContactInfoInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  number: Scalars['String'];
  sort?: InputMaybe<Scalars['Int']>;
  title: ContactInfoType;
};

export type UpdateCustomType = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type UpdateDeviceType = {
  description?: InputMaybe<Scalars['String']>;
  has_serial: Scalars['Boolean'];
  id: Scalars['ID'];
  importer_serial: Scalars['Boolean'];
  ranking: Scalars['Boolean'];
  ranking_end?: InputMaybe<Scalars['FrozenDate']>;
  ranking_start?: InputMaybe<Scalars['FrozenDate']>;
  sort?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  type_serial?: InputMaybe<Scalars['String']>;
};

export type UpdateEvent = {
  content: Scalars['String'];
  end_date: Scalars['DateTime'];
  header_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  location: Scalars['String'];
  notification_start?: InputMaybe<Scalars['DateTime']>;
  registration_until: Scalars['DateTime'];
  start_date: Scalars['DateTime'];
  title: Scalars['String'];
};

export type UpdateEventRegistration = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['ID'];
  last_name: Scalars['String'];
  position: EventRegistrationPosition;
};

export type UpdatePinInput = {
  classificationType?: InputMaybe<PinTypeEnum>;
  file_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  pinrules?: InputMaybe<Array<PinruleInput>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSaleInput = {
  consultant_id?: InputMaybe<Scalars['ID']>;
  customer_id?: InputMaybe<Scalars['ID']>;
  external_id?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  online?: InputMaybe<Scalars['Boolean']>;
  sold?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateStructure = {
  addresses?: Array<AddressInput>;
  contactInfos?: Array<ContactInfoInput>;
  custom_type_id?: InputMaybe<Scalars['ID']>;
  external_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  metadata?: InputMaybe<ClassificationMetadataInput>;
  parent_id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ClassificationTypeEnum>;
};

export type User = {
  __typename?: 'User';
  classifications: PorpaginasResult_NormalClassification;
  created: Scalars['DateTime'];
  deleted?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  isSuperuser?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  lastActionTime?: Maybe<Scalars['DateTime']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  role: Role;
  surname: Scalars['String'];
};

export type UserInput = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  last_name: Scalars['String'];
};

export type UsersFilterInput = {
  name?: InputMaybe<Scalars['String']>;
  type: Array<RoleSlugEnum>;
};

export type AllTypesMap = {
	Address: Address
	Article: Article
	ArticleClassification: ArticleClassification
	CalculatedClassification: CalculatedClassification
	CalculationEntry: CalculationEntry
	CalculationEntryInterface: CalculationEntryInterface
	Champion: Champion
	Classification: Classification
	ClassificationCode: ClassificationCode
	ClassificationCustomType: ClassificationCustomType
	ClassificationInterface: ClassificationInterface
	ClassificationMetadata: ClassificationMetadata
	ClassificationsPin: ClassificationsPin
	ClassificationsPinsRatingdata: ClassificationsPinsRatingdata
	CompareClassification: CompareClassification
	ContactInfo: ContactInfo
	DatedCalculationEntry: DatedCalculationEntry
	DatedEntryData: DatedEntryData
	DateDiff: DateDiff
	DatedInt: DatedInt
	DatedValue: DatedValue
	DatedValueInterface: DatedValueInterface
	DestructuredSerial: DestructuredSerial
	Device: Device
	DeviceCountClassification: DeviceCountClassification
	DeviceSerialInfo: DeviceSerialInfo
	DevicesSale: DevicesSale
	Devicetype: Devicetype
	EntryData: EntryData
	Event: Event
	EventRegistration: EventRegistration
	File: File
	GeneratedFile: GeneratedFile
	ImportDiffChildren: ImportDiffChildren
	ImportDiffData: ImportDiffData
	IntervalCalculationEntry: IntervalCalculationEntry
	Mutation: Mutation
	NormalClassification: NormalClassification
	Pin: Pin
	Pinrule: Pinrule
	Point: Point
	PorpaginasResult_Article: PorpaginasResult_Article
	PorpaginasResult_ArticleClassification: PorpaginasResult_ArticleClassification
	PorpaginasResult_CalculatedClassification: PorpaginasResult_CalculatedClassification
	PorpaginasResult_Champion: PorpaginasResult_Champion
	PorpaginasResult_ClassificationCode: PorpaginasResult_ClassificationCode
	PorpaginasResult_ClassificationCustomType: PorpaginasResult_ClassificationCustomType
	PorpaginasResult_Device: PorpaginasResult_Device
	PorpaginasResult_DeviceCountClassification: PorpaginasResult_DeviceCountClassification
	PorpaginasResult_DevicesSale: PorpaginasResult_DevicesSale
	PorpaginasResult_Devicetype: PorpaginasResult_Devicetype
	PorpaginasResult_Event: PorpaginasResult_Event
	PorpaginasResult_EventRegistration: PorpaginasResult_EventRegistration
	PorpaginasResult_NormalClassification: PorpaginasResult_NormalClassification
	PorpaginasResult_Pin: PorpaginasResult_Pin
	PorpaginasResult_Point: PorpaginasResult_Point
	PorpaginasResult_Quota: PorpaginasResult_Quota
	PorpaginasResult_RankedClassification: PorpaginasResult_RankedClassification
	PorpaginasResult_RankingLock: PorpaginasResult_RankingLock
	PorpaginasResult_Ratingdata: PorpaginasResult_Ratingdata
	PorpaginasResult_Sale: PorpaginasResult_Sale
	PorpaginasResult_Shipment: PorpaginasResult_Shipment
	PorpaginasResult_Star: PorpaginasResult_Star
	PorpaginasResult_User: PorpaginasResult_User
	QueuedJob: QueuedJob
	Quota: Quota
	RankedClassification: RankedClassification
	RankingLock: RankingLock
	Ratingdata: Ratingdata
	Role: Role
	Sale: Sale
	SaleStruct: SaleStruct
	Shipment: Shipment
	Star: Star
	StornoStruct: StornoStruct
	Subscription: Subscription
	SummedClassification: SummedClassification
	User: User
}